import { Lightbulb } from "lucide-react";

export const VibeCodingTakeaway = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl border border-primary/20 p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center shrink-0">
          <Lightbulb className="w-6 h-6 text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h3>
          <p className="text-muted-foreground leading-relaxed">
            Vibe coding isn't about replacing developers — it's about amplifying them. By describing what you want 
            in natural language and letting AI handle the implementation details, you can focus on architecture, 
            user experience, and solving real problems instead of fighting with syntax.
          </p>
        </div>
      </div>
    </div>
  );
};
